import React from 'react';

const TabIndexBtn = ({ children, css, handleClick }) => {
  return (
    <button
      className={`tabIndex-btn${css ? ' ' + css : ''}`}
      tabIndex={0}
      type='button'
      onClick={(e) => {
        handleClick();
        e.preventDefault();
        // e.stopPropagation();
      }}
    >
      {children}
    </button>
  );
};

export default TabIndexBtn;
